module.exports = __webpack_public_path__ + "static/media/alert-triangle.f9cab3eb.svg";